import { useEffect, useState } from 'react';
import './TeacherInvitedAfterMeeting.scss';

function TeacherInvitedAfterMeetingDone({
  user,
  courses,
  onCardClick,
  onGetUserCourses,
  onOpenModal,
  onNavigate,
}) {
  const [saving, setSaving] = useState(false);
  const [loadingCourses, setLoadingCourses] = useState(true);
  const firstName = user?.firstName || user?.profile?.firstName || '';
  const coursesPath = `/courses`;
  const dashboardPath = `/portfolio/${user?.username}`;
  const hasCourse = courses && courses.length > 0;

  useEffect(() => {
    // .catch before .finally: a course list that will not load is not a
    // reason to strand the teacher on a screen with no buttons, and without
    // this the rejection is unhandled. No courses is already a state this
    // screen renders.
    onGetUserCourses?.()
      .catch(() => {})
      .finally(() => setLoadingCourses(false));
    // eslint-disable-next-line
  }, []);

  async function handleClick(path) {
    setSaving(true);
    await onCardClick();
    onNavigate(path);
  }

  async function handleSetUpCourse() {
    setSaving(true);
    await onCardClick();
    onNavigate(coursesPath);
    setTimeout(() => {
      onOpenModal('manage-course', {});
    }, 1500);
  }

  return (
    <div className="teacher-invited-about-us">
      <div className="shell">
        <div className="step-eyebrow">You're in</div>
        <h1 className="step-h1">
          You're all set{firstName ? `, ${firstName}` : ''}.
        </h1>

        {!loadingCourses &&
          (hasCourse ? (
            <>
              <p className="step-sub">Now you can join your first course.</p>
              <div className="choice-cards">
                <button
                  type="button"
                  className="choice-card"
                  disabled={saving}
                  onClick={() => handleClick(coursesPath)}
                >
                  <div className="cc-title">Go to courses.</div>
                  <div className="cc-sub">View and join your courses.</div>
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="step-sub">What would you like to do first?</p>
              <div className="choice-cards">
                <button
                  type="button"
                  className="choice-card"
                  disabled={saving}
                  onClick={handleSetUpCourse}
                >
                  <div className="cc-title">Set up your first course.</div>
                  <div className="cc-sub">
                    Pick subject, students, and pace. About five minutes.
                  </div>
                </button>
                <button
                  type="button"
                  className="choice-card"
                  disabled={saving}
                  onClick={() => handleClick(dashboardPath)}
                >
                  <div className="cc-title">Just explore.</div>
                  <div className="cc-sub">
                    Look around the teacher dashboard at your own pace.
                  </div>
                </button>
              </div>
            </>
          ))}
      </div>
    </div>
  );
}

export default TeacherInvitedAfterMeetingDone;
